<template>
  <a-modal
    :width="600"
    :height="300"
    :visible="visible"
    :closable="false"
    :maskClosable="false"
    :destroyOnClose="true"
    :footer="null"
    :dialog-style="{top: '100px' }">
    <div style="font-weight: bold;font-size: 20px;">
    <p v-if="showDeprt">请选择项目所在的交易中心:</p>
    <p v-if="showDeprt">
      <a-tooltip placement="topLeft" >
      <template slot="title">
        <span>您隶属于多机构，请选择当前所在机构</span>
      </template>
      <a-avatar style="backgroundColor:#87d068" icon="gold" />
      </a-tooltip>
      <a-select v-model="departSelected" placeholder="请选择登录机构" style="margin-left:10px;width: 80%">
      <a-icon slot="suffixIcon" type="gold" />
        <a-select-option
          v-for="d in departList"
          :key="d.id"
          :value="d.orgCode">
          {{ d.departName }}
        </a-select-option>
      </a-select>
    </p>
    <p>请选择您要进行的操作:</p>
    <p>
      <a-radio-group name="radioGroup" v-model='radioValue'>
        <a-radio :value="1" style="margin: 5px">
          评标:正常项目评审
        </a-radio><br/>
        <a-radio :value="2" style="margin: 5px">
          复核:历史项目复核
        </a-radio><br/>
        <a-radio :value="3" style="margin: 5px">
          重评:历史项目重评
        </a-radio>
      </a-radio-group>
    </p>
    <p style="text-align: center"><a-button type='primary' @click='okSubmit()'>确定</a-button></p>
    </div>
  </a-modal>
</template>

<script>
import DepartSelect from "@comp/tools/DepartSelect.vue";
import {getAction, putAction} from "@api/manage";
import Vue from "vue";
import {USER_INFO} from "@/store/mutation-types";
import store from "@/store";
import {timeFix} from "@/utils/util";

export default {
  name: "AppraiseLoginSelectModal",
  components: {DepartSelect},
  data () {
    return {
      title: "选择",
      visible: false,
      departList:[],
      radioValue:null,
      departSelected:null,
      showDeprt:true,
    }
  },
  created(){
  },
  computed: {
  },
  methods: {
    load(userInfo) {
      console.log("userInfo",userInfo.multi_depart)
      if(userInfo.multi_depart!==2)
      {
        this.showDeprt=false;
      }
      this.visible = true;
      this.loadDepartList();
    },
    okSubmit()
    {
      //根据所选跳转页面，及切换地区
      let obj = {
        orgCode:this.departSelected,
        username:this.username
      }
      putAction("/sys/selectDepart",obj).then(res=>{
        if(res.success){
          const userInfo = res.result.userInfo;
          console.log("userInfo",userInfo);
          Vue.ls.set(USER_INFO, userInfo, 7 * 24 * 60 * 60 * 1000);
          store.commit('SET_INFO', userInfo);
          //根据所选的
          if(this.radioValue==null)
          {
            this.$warning({
              title: '系统提示',
              content: "请选择跳转界面！",
            });
            return;
          }
          let url;
          if(this.radioValue===1){
             url="/iebideval/wait";
          }else if(this.radioValue===2||this.radioValue===3){
            url="/iebideval/his";
          }
          this.$router.push({ path: url }).catch((err)=>{
            console.log('登录跳转首页出错,这个错误从哪里来的')
          });
          this.$notification.success({
            message: '欢迎',
            description: `${timeFix()}，欢迎回来`,
          });
        }
      })

    },
    loadDepartList(){
      return new Promise(resolve => {
        let url = "/sys/user/getCurrentUserDeparts"
        this.currDepartName=''
        getAction(url).then(res=>{
          if(res.success){
            console.log(res.result)

            let departs = res.result.list
            let orgCode = res.result.orgCode
            if(departs && departs.length>0){
              for(let i of departs){
                if(i.orgCode == orgCode){
                  this.currDepartName = i.departName
                  break
                }
              }
            }
            this.departSelected = orgCode
            this.departList  = departs
            if(this.currDepartName){
              this.currTitle ="中心切换（当前中心 : "+this.currDepartName+"）"
            }
          }
          resolve()
        })
      })
    },
  }
}
</script>

<style lang="less" scoped>

</style>